import React from 'react';
import { ButtonContainer, LoadingContainer, Text } from './Button.styles';
import { Waveform } from '@uiball/loaders';

const Button = ({
  title,
  disabled,
  containerStyle,
  titleStyle,
  onClick,
  loading,
  centered,
  leftIcon,
  width,
  loadingCreate,
  isWhite,
}) => {
  return (
    <ButtonContainer
      $width={width}
      style={containerStyle}
      onClick={!disabled || loading ? onClick : null}
      $disabled={disabled || loading}
      $centered={centered}>
      {!loading ? (
        <>
          {leftIcon}
          <Text $disabled={disabled} style={titleStyle}>
            {title}
          </Text>
        </>
      ) : (
        <LoadingContainer>
          <Waveform size={26} lineWeight={3.5} speed={1} color={isWhite ? 'white' : 'black'} />
        </LoadingContainer>
      )}
    </ButtonContainer>
  );
};

export default Button;
